export const actions = {
	async login({ dispatch }, { user }) {
		return await useNuxtApp()
			.$api('/api-token-auth/', {
				method: 'POST',
				body: {
					username: user.email,
					password: user.password,
				},
			})
			.then((res) => {
				useCookie('auth', {
					expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 365),
					path: '/app/',
				}).value = res
				useCookie('token', {
					expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 365),
					path: '/',
				}).value = res.token
				useCookie('refresh_token', {
					expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 365),
					path: '/',
				}).value = res.refresh_token
				useCookie('access_token', {
					expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 365),
					path: '/',
				}).value = res.access_token
				dispatch('callCommitAuth', res, { root: true })
			})
	},

	logout({ dispatch }) {
		useCookie('auth', {
			expires: 0,
			path: '/app/',
		}).value = null
		useCookie('token', {
			expires: 0,
			path: '/',
		}).value = null
		useCookie('refresh_token', {
			expires: 0,
			path: '/',
		}).value = null
		useCookie('access_token', {
			expires: 0,
			path: '/',
		}).value = null

		dispatch('callCommitAuthLogout', null, { root: true })
	},

	askEmailChangePassword(_, { email }) {
		return useNuxtApp().$api('/api/companies/forgotten_password/', {
			method: 'POST',
			body: {
				email,
			},
		})
	},

	async checkTokenNewPassword(_, { token }) {
		return await useNuxtApp().$api(
			`/api/companies/check_token_forgotten_password/?token_forgotten_password=${token}`,
			{},
		)
	},

	async changeNewPassword(_, { password, passwordConfirm, token }) {
		return await useNuxtApp().$api('/api/companies/change_forgotten_password/', {
			method: 'POST',
			body: {
				password,
				confirm_password: passwordConfirm,
				token_forgotten_password: token,
			},
		})
	},

	async authTwitter({ commit }) {
		commit('setIsLoading', true)

		return await useNuxtApp()
			.$api(`/api/companies/auth_twitter/`, {})
			.then((res) => {
				return res
			})
			.catch((_err) => {
				return _err
			})
	},

	async registerTwitter(_, { oauthToken, oauthVerifier }) {
		return await useNuxtApp().$api(`/api/companies/callback_auth_twitter/`, {
			method: 'POST',
			body: {
				oauth_token: oauthToken,
				oauth_verifier: oauthVerifier,
			},
		})
	},
}
